<div class="common-page">
  <div class="page-container">
    <div class="page-thumbnail">
      <img src="assets/images/illu_page_404_not_found.png" alt="">
    </div>
    <div class="page-titles text-center">
      <h2>{{'general.pageNotFound' | translate}}</h2>
      <p>{{'general.pageNotFoundMessage' | translate}}</p>

      <a mat-raised-button color='primary' [routerLink]="['/']">
        {{'general.goToHomepage' | translate}}
      </a>
    </div>
  </div>
</div>